import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventoryItineraryComponent } from './inventory-itinerary.component';
import { ItineraryListComponent } from './list/itinerary-list.component';
import { ItineraryDetailsComponent } from './add/itinerary-details/itinerary-details.component';

const routes: Routes = [
  { path: '', component:InventoryItineraryComponent, 
    children: [
      { path: '' , redirectTo: 'list', pathMatch: 'full'},
      {path: 'list', component: ItineraryListComponent},
    ]
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventoryItineraryRoutingModule { }
